export { default as ProductsAiSearchImageDetect } from './ProductsAiSearchImageDetect';
